import type { SourceState } from '../lib/types';
import { formatRelativeAge } from '../lib/format';
import styles from './SourceStatusBadge.module.css';

const SOURCE_LABEL: Record<SourceState['source'], string> = {
  blockstream: 'Blockstream',
  coingecko: 'CoinGecko',
  coinbase: 'Coinbase',
};

export function SourceStatusBadge({ source }: { source: SourceState }) {
  const status = source.stale ? 'stale' : source.ok ? 'ok' : 'down';
  const label = SOURCE_LABEL[source.source];
  const statusText =
    status === 'ok'
      ? 'live'
      : status === 'stale'
        ? `stale · ${formatRelativeAge(source.lastSuccessAt)}`
        : 'unavailable';

  return (
    <span className={`${styles.badge} ${styles[status]}`}>
      <span className={styles.dot} aria-hidden="true" />
      {label}: {statusText}
    </span>
  );
}
